
import { Observable } from 'rxjs';
import {Faq} from "@/src/entities/faq";
import {DataInteractor} from "@/src/interactors/dataInteractor";
import {LanguageEnum} from "@/src/entities/languageEnum";
import {Review} from "@/src/entities/review";
import {Condition} from "@/src/entities/condition";
import {Lodging} from "@/src/entities/lodging";

export class DataViewModel {

    private dataInteractor: DataInteractor

    constructor() {
        this.dataInteractor = new DataInteractor();
    }
    public retrieveFaqList(language: LanguageEnum): Observable<Faq[]> {
        return this.dataInteractor.retrieveFaqList(language)
    }
    public retrieveReviewList(language: LanguageEnum): Observable<Review[]> {
        return this.dataInteractor.retrieveReviewList(language)
    }

    public retrieveConditionList(language: LanguageEnum, email: string, phone: string): Observable<Condition[]> {
        return this.dataInteractor.retrieveConditionList(language, email, phone)
    }

    public retrieveLodgingList(language: LanguageEnum): Observable<Lodging[]> {
        return this.dataInteractor.retrieveLodgingList(language)
    }
}